"use client";
import { createSession } from '@/actions/authActions';
import { createCookie, getCookie } from '@/actions/coockiesActions';
import { auth } from '@/services/firebase.service';
import { userServices } from '@/services/Users';
import emailjs from '@emailjs/browser';
import { signInWithEmailAndPassword } from 'firebase/auth';

export async function contact(prev, formData) {

  const body = {
    user_name: formData.get('user_name'),
    user_email: formData.get('user_email'),
    message: formData.get('message')
  }

  const { cookie } = await getCookie('emails');
  if (cookie)
    if (cookie >= 3)
      return { message: 'No puedes enviar mas mails en el dia', status: 401 }

  try {
    const response = await emailjs.send("service_e98xkuq", "template_m6hqsqx", body, 'gQ8sJoVzvDr6-TAtC');

    switch (response.status) {
      case 200:
        const moreSpam = Number(cookie) + 1
        const spamValue = moreSpam.toString()
        await createCookie('emails', spamValue)
        return { message: 'Mensaje enviado con exito', status: 200 }
      default:
        return { message: 'Error al enviar un mensjae', status: 400 }
    }
  } catch (error) {
    return { message: 'Error al enviar un mensjae', status: 400 }
  }
}

export async function loginClient(prev, formData) {

  const body = {
    email: formData.get('email'),
    password: formData.get('password')
  }

  const remember = formData.get('remember')

  try {
    // It checks for the existence of the token in the cookies.
    const credentials = await signInWithEmailAndPassword(auth, body.email, body.password)
    const user = credentials.user
    const { getUserById } = userServices();
    const { data, status } = await getUserById(user.uid)
    if (status === 200) {
      if (data) {
        await createSession(user.accessToken, remember)
        return { message: `Bienvenido ${user.email}`, status: 201 };
      } else {
        return { message: 'Usuario no encontrado', status: 400 };
      }
    } else{
      return { message: 'Usuario no encontrado', status: 400 };
    }
  } catch (error) {
    console.log(error)
    return {
      message: "Usuario no encontrado",
      status: 500 // Return a server error status if an exception occurs
    }
  }
}
